// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V9 → V10
 *
 * Pro-Glied-Präfix für Bodenform-Paare. Vorher gab es einen einzigen globalen
 * `bodenform.prefix`, der für die gesamte Kombi galt. Ab V10 trägt jedes
 * `bodenform.bf[i]` einen eigenen optionalen `prefix`, sodass z. B. nur das
 * begrabene Glied einer Doppel-Bodenform ein "b" führen kann (BB / bSS).
 *
 * Upgrade:
 * - bodenform.prefix → bodenform.bf[0].prefix (wenn bf[0] existiert)
 * - bodenform.prefix entfernen
 *
 * Downgrade:
 * - bodenform.bf[0].prefix → bodenform.prefix (lossy: höhere Glied-Präfixe gehen verloren)
 * - alle bodenform.bf[i].prefix entfernen
 */
export const migrationV9ToV10: MigrationDefinition = {
  fromVersion: 9,
  toVersion: 10,

  upgrade(doc: any): any {
    const bodenform = doc.header?.bodenform;
    if (bodenform && typeof bodenform.prefix === 'string') {
      const arr = Array.isArray(bodenform.bf) ? bodenform.bf : null;
      if (arr && arr.length > 0 && bodenform.prefix) {
        arr[0].prefix = bodenform.prefix;
      }
      delete bodenform.prefix;
    }
    doc.version = 10;
    return doc;
  },

  downgrade(doc: any): any {
    const bodenform = doc.header?.bodenform;
    if (bodenform && Array.isArray(bodenform.bf)) {
      const firstPrefix = bodenform.bf[0]?.prefix;
      if (firstPrefix) {
        bodenform.prefix = firstPrefix;
      }
      for (const pair of bodenform.bf) {
        if (pair && typeof pair === 'object') delete pair.prefix;
      }
    }
    doc.version = 9;
    return doc;
  },

  dataLossWarnings: [
    'Pro-Glied-Präfixe ab dem 2. Bodenform-Paar (bf[1].prefix, bf[2].prefix) gehen beim Downgrade verloren'
  ]
};
